import React from "react";
import AuthMsalProvider from "./msal/AuthMsalProvider";

const AuthProvider = ({ children }: React.PropsWithChildren) => {
  // could return other providers for other auth
  return <AuthMsalProvider>{children}</AuthMsalProvider>;
};

export default AuthProvider;
